import dotProp from 'dot-prop-immutable'
import { connect } from 'react-redux'
import { toggleNavigationProducts } from '../../actions/sidebar'
import getProducts from '../../repositories/getProducts'
import NavigationItem from './../../components/NavigationItem'

const mapStateToProps = state => ({
  isToggled: dotProp.get(state, `sidebar.products.isToggled`, false),
})

const mapDispatchToProps = dispatch => ({
  toggle: () => dispatch(toggleNavigationProducts(getProducts(window.fetch))),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NavigationItem)



// WEBPACK FOOTER //
// ./src/containers/NavigationItem/ProductItem.js